import React from 'react';
import PropTypes from 'prop-types';

import Dropzone from 'react-dropzone';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faPaperclip } from '@fortawesome/pro-solid-svg-icons';
import { ProgressBar } from 'react-bootstrap';

import api from 'components/attachments/api';

import AttachmentsRow from './row';

import './styles.scss';

export class Attachments extends React.Component {
  static propTypes = {
    attachable: PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired
    }).isRequired,
    attachments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
    attachmentsPath: PropTypes.string.isRequired,
    deleteEnabled: PropTypes.bool,
    dropzone: PropTypes.node,
    dropzoneOnly: PropTypes.bool,
    forUserId: PropTypes.number,
    onAddAttachment: PropTypes.func.isRequired,
    onDeleteAttachment: PropTypes.func.isRequired,
  }

  state = {
    uploading: false
  }

  handleUpload = (files) => {
    if (files.length === 0) {
      return;
    }

    this.setState({ progress: 0, progressMap: {}, uploading: true });
    const config = index => ({ onUploadProgress: this.handleUploadProgress(index) });

    const uploads = files.map((file, i) => (
      api.createAttachment(this.props.attachmentsPath, this.props.attachable, file, config(i))
        .then((attachment) => {
          this.props.onAddAttachment(attachment);
        })
    ));

    Promise.all(uploads).then(() => this.setState({ uploading: false }));
  }

  handleUploadProgress = index => (event) => {
    const { progressMap } = this.state;
    progressMap[index] = event;
    const allLoaded = Object.values(progressMap).map(prog => prog.loaded).reduce((sum, loaded) => sum + loaded, 0);
    const allTotal = Object.values(progressMap).map(prog => prog.total).reduce((sum, size) => sum + size, 0);
    this.setState({ progress: Math.floor(allLoaded * 100 / allTotal), progressMap });
  }

  render() {
    if (this.props.dropzoneOnly) {
      return (
        <div className="backoffice-attachments">
          {this.renderDropzone()}
        </div>
      );
    }

    return (
      <div className="backoffice-attachments">
        <div className="row">
          <div className="col-xs-12 top-buffer-sm">
            {this.renderDropzone()}
          </div>
        </div>
        {this.props.attachments.length > 0 && this.renderAttachments()}
      </div>
    );
  }

  renderDropzone() {
    const { dropzone } = this.props;

    return (
      <Dropzone onDrop={this.handleUpload}>
        {({ getRootProps, getInputProps }) => (
          <div
            className={classNames('clickable', { 'text-center': !dropzone, uploader: !dropzone })}
            {...getRootProps()}
          >
            {this.state.uploading ? this.renderProgressBar() : (dropzone || this.renderDropzoneText())}
            <input {...getInputProps()} />
          </div>
        )}
      </Dropzone>
    );
  }

  renderDropzoneText() {
    return (
      <React.Fragment>
        <FontAwesomeIcon className="right-buffer-sm text-muted fa-fw" icon={faImage} size="lg" />
        <span className="text-muted">
          Click or drag files or folders here to upload them.
        </span>
      </React.Fragment>
    );
  }

  renderProgressBar() {
    return <ProgressBar active now={this.state.progress} />;
  }

  renderAttachments() {
    const { attachmentsPath, deleteEnabled, onDeleteAttachment } = this.props;

    return (
      <div className="row">
        <div className="col-xs-12 backoffice-table-wrapper">
          <table className="table backoffice-attachments-table sticky-actions top-buffer-md">
            <thead>
              <tr>
                <td className="fixed-width">
                  <FontAwesomeIcon className="text-muted" icon={faPaperclip} />
                </td>
                <td className="name">
                  Attachment Name
                </td>
                <td className="actions fixed-width">
                  Action
                </td>
              </tr>
            </thead>
            <tbody>
              {this.props.attachments.map(attachment => (
                <AttachmentsRow
                  attachment={attachment}
                  attachmentsPath={attachmentsPath}
                  deleteEnabled={deleteEnabled}
                  forUserId={this.props.forUserId}
                  key={attachment.id}
                  onDeleteAttachment={onDeleteAttachment}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default Attachments;
